import { render, staticRenderFns } from "./logistic-load-list.vue?vue&type=template&id=368540b1&scoped=true"
import script from "./logistic-load-list.ts?vue&type=script&lang=js&external"
export * from "./logistic-load-list.ts?vue&type=script&lang=js&external"
import style0 from "./logistic-load-list.vue?vue&type=style&index=0&id=368540b1&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368540b1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAlert,VBtn,VCheckbox,VToolbar,VToolbarTitle})
